import { ResourceKey } from './resource-key';

export class RestoreRequeueRequest {
    backupServiceId: string;
    resourceKey: ResourceKey;
    jobSerialization: string;
    queueNewJob: boolean;
}
